import React, { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { validateToken } from "./ValidateToken";

const ProtectedRoute = () => {
    const [isValid, setIsValid] = useState(null);

    useEffect(() => {
        let cancelled = false;
        const checkToken = async () => {
            const valid = await validateToken();
            if (!cancelled) setIsValid(valid);
        };
        checkToken();
        return () => {
            cancelled = true;
        };
    }, []);

    if (isValid === null) {
        return <div>Loading...</div>;
    }

    return isValid ? <Outlet /> : <Navigate to="/login" />;
};

export default ProtectedRoute;